import React, {FC} from "react"
import {Grid, Modal, ModalBody} from "react-bootstrap"

import id from "@irati/utils/id"

import Close from "../Close"

import "./FullModal.css"

interface Props {
  id?: string,
  className?: string,
  show: boolean,
  onEnter?: () => void,
  onHide: () => void,
  onScroll?: () => void
}

const FullModal: FC<Props> = (props) => {
  const idNamespace = id("full-modal", props, {force: true})
  const {className, show, onEnter, onHide, onScroll} = props

  return (
    <Modal
      id={idNamespace}
      bsSize="lg"
      show={show}
      onHide={onHide}
      onEnter={onEnter}
      className={`full-modal ${className}`}
      onScroll={onScroll}>
      <ModalBody>
        <Grid>
          <Close id={id("btn-close", idNamespace)} top="20px" right="30px" onClick={onHide} />
          {props.children}
        </Grid>
      </ModalBody>
    </Modal>
  )
}

FullModal.defaultProps = {
  className: "",
  onEnter: () => {},
  onScroll: () => {}
}

export default FullModal
